export class HolviSharedUriService {
  startHolviCustomerQueueTyojonoUri(tyojonoAvain: string) {
    return this.startHolviCustomerQueueTyojonoCollection() + '/' + tyojonoAvain
  }

  startHolviCustomerQueueTyojonoCollection() {
    return 'tyojono/holvi/holvi-customer-queue-group'
  }

  startHolviTransactionFetchTyojonoUri(asiakasAvain: string, tyojonoAvain: string) {
    return this.startHolviTransactionFetchTyojonoCollection(asiakasAvain) + '/' + tyojonoAvain
  }

  startHolviTransactionFetchTyojonoCollection(asiakasAvain: string) {
    return 'tyojono/' + asiakasAvain + '/holvi-transaction-fetch'
  }

  getManualTransactionFetchLogCollection(asiakasAvain: string) {
    return 'asiakkaat/' + asiakasAvain + '/holvi-transaction-fetch-logs'
  }

  getManualTransactionFetchLogUri(asiakasAvain: string, logAvain: string) {
    return this.getManualTransactionFetchLogCollection(asiakasAvain) + '/' + logAvain
  }
}
